import React, { useState } from 'react';
import DialogWrapper from '../custom-ui/dialog/Dialog';
import useModal from '../../hooks/useModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import toast from 'react-hot-toast';
import { csvDownload } from '../dashboard/AdminMetricDashboard/ExportCsv';
import ToastAlert from '../custom-ui/toast-alert/ToastAlert';
import DownloadIconWithLabel from '../dashboard/AdminMetricDashboard/DownLoadIcon';
import Tooltip from '../custom-ui/tooltip/tooltip_NewUI';

const PAGE_SIZE = 10;

const JobCompletionStats = ({ jobsData }: any) => {
    const filledJobsData: any = jobsData.filter(
        (job: any) => job.jobState === "closed_filled" || job.jobState === "closed_cancelled" || job.jobState === "closed_job_expired"
    );


    const getJobStatus = (jobState: string) => {
        switch (jobState) {
            case "closed_filled":
                return "Filled";
            case "closed_cancelled":
                return "Cancelled";
            case "closed_job_expired":
                return "Expired";
            default:
                return "N/A";
        }
    };

    const dataToDisplay = filledJobsData.map((job: any) => ({
        "Job Title": job.jobName,
        "Employer Name": job.companyFullName,
        "Closure Date": new Date(job.latestUpdate?.seconds * 1000).toLocaleDateString("en-US", {
            year: "numeric",
            month: "numeric",
            day: "numeric",
        }),
        "Closure Status": getJobStatus(job.jobState),
        "Filled Via": job.closedFilledBy == "others" ? "Others" : job.closedFilledBy == "Instant Teams" || "N/A",
        "Reason": job.closedReason || "N/A",
    }));




    const handleCsvDownload = () => {
        if (dataToDisplay.length > 0) {
            csvDownload(dataToDisplay, "job-completion-stats.csv");
        } else {
            toast.error("No data available for download");
        }

    }

    return (
        <>
            <div>

               
                <button onClick={handleCsvDownload} className='bg-instant-teams-blue-Main px-9 flex py-1 text-white mb-4'>
                    Download
                    <DownloadIconWithLabel  isFromEmpMetric={true} viewDown={true} tooltipText={"Download job data marked as Closed, Cancelled, or Expired within the last 90 days."} />
                    </button>
                    
        

            </div>
            <ToastAlert />
        </>
    );
};

export default JobCompletionStats;
